'use client';
import { BaseOWTrackingService } from '@ow/shared/services/tracking/base-ow-tracking.service';
import {
  isOverwolfAvailable,
  getOverwolfVersion,
  getOverwolfMachineInfo,
} from '../overwolf/overwolf-api.service';

// -----------------------------------------------------------------------------
// The website's binding of the shared BaseOWTrackingService (the HTTP counter).
// The send logic lives in @ow/shared; here we only supply the website
// environment:
//   - platform: 'owClient' only inside the Overwolf client iframe;
//   - client dimensions: from the injected window.overwolf (overwolf-api).
export class OWTrackingService extends BaseOWTrackingService {
  constructor() {
    super({
      // Embedded as an iframe inside the Overwolf client we're 'owClient';
      // everywhere else (plain browser) we're 'Web'. On the server there's no
      // window, so we report 'Web' and the client singleton recomputes.
      getPlatform: () => {
        if (typeof window === 'undefined') {
          return 'Web';
        }
        const isIframe = window.self !== window.top;
        return isIframe && isOverwolfAvailable() ? 'owClient' : 'Web';
      },
      // owver from the injected client; MUID / MUIDV2 from getCurrentUser. Null
      // until the machine ids are present, so a later event retries.
      loadOwParams: async () => {
        const params: Record<string, string> = {};

        const owver = getOverwolfVersion();
        if (owver) {
          params.owver = owver;
        }

        const { machineId, machineIdV2 } = await getOverwolfMachineInfo();
        if (machineId) {
          params.MUID = machineId;
        }
        if (machineIdV2) {
          params.MUIDV2 = machineIdV2;
        }

        return machineId || machineIdV2 ? params : null;
      },
    });
  }
}
